export default "__VITE_PUBLIC_ASSET__c8ce7f1b__"